import request from '@/service/request'

// 修改锚点显示状态
export function updateAnchorShowStatusService(data) {
    return request.put('/scene/v3/updateAnchorPointShowStatus', data);
}